export const Languages = [
  { name: 'ABAP', value: 'abap', ext: '' },
  { name: 'AES', value: 'aes', ext: '' },
  { name: 'Apex', value: 'apex', ext: '' },
  { name: 'Azure CLI', value: 'azcli', ext: '' },
  { name: 'Bat', value: 'bat', ext: '.bat' },
  { name: 'C', value: 'c', ext: '.c' },
  { name: 'Clojure', value: 'clojure', ext: '.clj' },
  { name: 'CoffeeScript', value: 'coffeescript', ext: '.litcoffee' },
  { name: 'C++', value: 'cpp', ext: '.cpp' },
  { name: 'C#', value: 'csharp', ext: '.cs' },
  { name: 'CSP', value: 'csp', ext: '' },
  { name: 'CSS', value: 'css', ext: '.css' },
  { name: 'Docker', value: 'dockerfile', ext: '' },
  { name: 'F#', value: 'fsharp', ext: '.fs' },
  { name: 'Go', value: 'go', ext: '.go' },
  { name: 'GraphQL', value: 'graphql', ext: '.graphql' },
  { name: 'Handlebars', value: 'handlebars', ext: '' },
  { name: 'HTML', value: 'html', ext: '.html' },
  { name: 'ini', value: 'ini', ext: '.ini' },
  { name: 'Java', value: 'java', ext: '.java' },
  { name: 'JavaScript', value: 'javascript', ext: '.js' },
  { name: 'JSON', value: 'json', ext: '.json' },
  { name: 'Kotlin', value: 'kotlin', ext: '.kts' },
  { name: 'LESS', value: 'less', ext: '.less' },
  { name: 'Lua', value: 'lua', ext: '.lua' },
  { name: 'Markdown', value: 'markdown', ext: '.md' },
  { name: 'MIPS', value: 'mips', ext: '' },
  { name: 'Microsoft DAX', value: 'msdax', ext: '' },
  { name: 'MySQL', value: 'mysql', ext: '.sql' },
  { name: 'Objective-C', value: 'objective-c', ext: '.mm' },
  { name: 'Pascal', value: 'pascal', ext: '.pas' },
  { name: 'Perl', value: 'perl', ext: '.pl' },
  { name: 'PostgreSQL', value: 'pgsql', ext: '.sql' },
  { name: 'PHP', value: 'php', ext: '.php' },
  { name: 'Plain Text', value: 'plaintext', ext: '.txt' },
  { name: 'Power Query', value: 'powerquery', ext: '' },
  { name: 'Power Shell', value: 'powershell', ext: '.ps1' },
  { name: 'Pug', value: 'pug', ext: '' },
  { name: 'Python', value: 'python', ext: '.py' },
  { name: 'R', value: 'r', ext: '.R' },
  { name: 'Razor', value: 'razor', ext: '' },
  { name: 'Redis', value: 'redis', ext: '' },
  { name: 'Redshift', value: 'redshift', ext: '' },
  { name: 'reStructuredText', value: 'restructuredtext', ext: '' },
  { name: 'Ruby', value: 'ruby', ext: '.rb' },
  { name: 'Rust', value: 'rust', ext: '.rs' },
  { name: 'Small Basic', value: 'sb', ext: '' },
  { name: 'Scheme', value: 'scheme', ext: '.scm' },
  { name: 'SCSS', value: 'scss', ext: '' },
  { name: 'Shell', value: 'shell', ext: '' },
  { name: 'SOL', value: 'sol', ext: '' },
  { name: 'SQL', value: 'sql', ext: '.sql' },
  { name: 'Structured Text', value: 'st', ext: '' },
  { name: 'Swift', value: 'swift', ext: '.swift' },
  { name: 'Tcl', value: 'tcl', ext: '.tcl' },
  { name: 'Twig', value: 'twig', ext: '.twig' },
  { name: 'Typescript', value: 'typescript', ext: '.ts' },
  { name: 'Visual Basic', value: 'vb', ext: '.vb' },
  { name: 'XML', value: 'xml', ext: '.xml' },
  { name: 'YAML', value: 'yaml', ext: '.yml' },
];
